<template>
  <div>
    <v-card>
      <v-data-table
        :headers="headers"
        :items="dados"
        disable-sort
        :server-items-length="total"
        :options.sync="options"
        loading-text="Carregando... Por favor aguarde"
        :loading="carregando"
        class="elevation-1 base_table mt-4"
        :footer-props="{
          itemsPerPageOptions: [5,10,15,20,25,50,100],
          showFirstLastPage: true,
          firstIcon: 'skip_previous',
          lastIcon: 'skip_next',
          prevIcon: 'chevron_left',
          nextIcon: 'chevron_right'
        }"
        :header-props="{
          sortIcon: 'north',
        }"
      >
        <template v-slot:top>
          <v-row no-gutters align="center" justify="space-between" class="flex-md-nowrap">
            <v-col cols="12" md="11">
              <v-row no-gutters align="center">
                <v-col cols="12" md="4" class="py-2 px-2" v-if="!disableDatePicker">
                  <VueCtkDateTimePicker
                    position="bottom"
                    v-on:callback="changeDates"
                    v-model="data_entrada"
                    class="date-picker"
                    locale="pt-BR"
                    :no-header="true"
                    :no-value-to-custom-elem="true"
                    :overlay="true"
                    :range="true"
                    :formatted="'L'"
                    :format="'YYYY-MM-DD'"
                    color="#004A93"
                    :dark="$vuetify.theme.dark"
                    button-color="#EC6521"
                    :custom-shortcuts="labels"
                    :no-button="true"
                    :noClearButton="true"
                    :auto-close="true"
                    :loading="carregando"
                    :disabled="carregando"
                    :submit="retornoData()"
                  >
                    <v-btn class="px-2 ui-search_btn w-100" elevation="0" v-ripple="{ class: `success--text` }">
                      <b :class="'text ' + ($vuetify.theme.dark ? '' : 'text-primary')">
                        Período: {{ formatDateFront(de, 'LL')}} - {{formatDateFront(ate, 'LL') }}
                      </b>
                    </v-btn>
                  </VueCtkDateTimePicker>
                </v-col>
                <v-col cols="12" md="8" class="pt-0" v-if="$root.Permissions.admin() && $route.name == 'Tarefas'"></v-col>
                <v-col cols="12" md="2" class="py-2 px-2">
                  <v-form @submit.prevent="applyFilter()">
                    <v-text-field
                      clearable
                      hide-details=""
                      clear-icon="close"
                      v-model="search"
                      outlined
                      label="Busca"
                      @click:clear="limparBusca()"
                    ></v-text-field>
                  </v-form>
                </v-col>
                <v-col cols="12" md="2" class="py-2 px-2" v-if="$root.Permissions.admin()">
                  <v-autocomplete
                    :menu-props="{ offsetY: true}"
                    v-model="distribuidor"
                    :items="distribuidores"
                    hide-details=""
                    clearable
                    clear-icon="close"
                    label="Distribuidor"
                    append-icon="expand_more"
                    outlined
                    @change="applyFilter()"
                    @click:clear="applyFilter()"
                  >
                  </v-autocomplete>
                </v-col>
                <v-col cols="12" md="2" class="py-2 px-2" v-if="$root.Permissions.admin()">
                  <v-autocomplete
                    :menu-props="{ offsetY: true}"
                    v-model="integrador"
                    :items="integradores"
                    hide-details=""
                    clearable
                    clear-icon="close"
                    label="Integrador"
                    append-icon="expand_more"
                    outlined
                    @change="applyFilter()"
                    @click:clear="applyFilter()"
                  >
                  </v-autocomplete>
                </v-col>
                <v-col cols="12" md="2" class="py-2 px-2">
                  <v-autocomplete
                    :menu-props="{ offsetY: true}"
                    v-model="usuario"
                    :items="usuarios"
                    hide-details=""
                    clearable
                    clear-icon="close"
                    label="Usuário"
                    append-icon="expand_more"
                    outlined
                    @change="applyFilter()"
                    @click:clear="applyFilter()"
                  >
                  </v-autocomplete>
                </v-col>
                <v-col cols="12" md="2" class="py-2 px-2">
                  <v-autocomplete
                    :menu-props="{ offsetY: true}"
                    v-model="status"
                    :items="statusArr"
                    hide-details=""
                    clearable
                    clear-icon="close"
                    label="Status"
                    append-icon="expand_more"
                    outlined
                    @change="applyFilter()"
                    @click:clear="applyFilter()"
                  >
                  </v-autocomplete>
                </v-col>
                <v-col cols="12" md="2" class="py-2 px-2">
                  <v-autocomplete
                    :menu-props="{ offsetY: true}"
                    v-model="prioridade"
                    :items="prioridades"
                    hide-details=""
                    clearable
                    clear-icon="close"
                    label="Prioridade"
                    append-icon="expand_more"
                    outlined
                    @change="applyFilter()"
                    @click:clear="applyFilter()"
                  >
                  </v-autocomplete>
                </v-col>
                <!-- <div class="py-2 px-2">
                  <v-autocomplete
                    :menu-props="{ offsetY: true}"
                    v-model="tipo"
                    :items="tipos"
                    hide-details=""
                    clearable
                    clear-icon="close"
                    label="Tipo"
                    append-icon="expand_more"
                    outlined
                    @change="applyFilter()"
                    @click:clear="applyFilter()"
                  >
                  </v-autocomplete>
                </div> -->
              </v-row>
            </v-col>
            <v-col cols="12" md="1">
              <div class="py-2 px-2 d-flex justify-end">
                <v-menu
                  bottom
                  center
                  offset-y
                  max-height="400"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <div v-bind="attrs" v-on="on" class="d-flex">
                      Exportar
                      <v-icon>arrow_drop_down</v-icon>
                    </div>
                  </template>
                  <v-list>
                    <v-list-item @click="exportXls()">
                      <v-list-item-icon class="mr-1">
                        <v-icon color="primary">receipt_long</v-icon>
                      </v-list-item-icon>
                      <v-list-item-title>Exportar para XLS</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </div>
            </v-col>
          </v-row>
        </template>
        <template v-slot:item.tar_data="{ item }">
          {{$root.Formatter.formatDate(item.tar_data)}}
        </template>
        <template v-slot:item.oportunidade="{ item }">
          <div v-if="item.oportunidade">
            <span
              class="caption tarefa-link"
              @click="goToOportunidade(item.oportunidade.uuid_opu_id)"
            >
              Cod. {{ item.oportunidade.opu_id }}
            </span>
            /
            <span
              class="caption tarefa-link"
              @click="goToContact(item.oportunidade.cliente.uuid_cli_id)"
            >
              {{ item.oportunidade.cliente.cli_nome }}
            </span>
          </div>
        </template>
        <template v-slot:item.tar_prioridade="{ item }">
          <v-chip small label :color="prioridades[item.tar_prioridade - 1].color" text-color="white">
            {{ prioridades[item.tar_prioridade - 1].text }}
          </v-chip>
        </template>
        <template v-slot:item.tar_status="{ item }">
          <v-chip small label :color="statusArr[item.tar_status - 1].color" text-color="white">
            {{ statusArr[item.tar_status - 1].text }}
          </v-chip>
        </template>
        <template v-slot:item.tar_tipo="{ item }">
          <v-chip small label :color="tipos[item.tar_tipo - 1].color" text-color="white">
            {{ tipos[item.tar_tipo - 1].text }}
          </v-chip>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-row no-gutters align="center" justify="center">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon v-bind="attrs" v-on="on" @click="openDialog(item)" color="primary" class="mr-2">
                  edit
                </v-icon>
              </template>
              <span>Editar</span>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon v-bind="attrs" v-on="on" @click="opendialogDelete(item)" color="primary" class="ml-2">
                  delete
                </v-icon>
              </template>
              <span>Excluir</span>
            </v-tooltip>
          </v-row>
        </template>
      </v-data-table>
    </v-card>
    <v-dialog
      v-model="dialog"
      persistent
      max-width="400px"
    >
      <v-card class="ui-dialog-top">
        <v-row align="center" justify="space-between">
          <v-col cols="10">
            {{tarefa.uuid_tar_id ? 'Editar tarefa' : 'Nova tarefa'}}
          </v-col>
          <v-col cols="2" class="text-right">
            <v-icon @click="closeDialog()">close</v-icon>
          </v-col>
        </v-row>
      </v-card>
      <v-card class="ui-dialog-content">
        <v-form ref="formTarefa">
          <v-autocomplete
            v-if="$root.Permissions.admin()"
            :menu-props="{ offsetY: true}"
            v-model="tarefa.uuid_dis_id"
            :items="distribuidores"
            clearable
            clear-icon="close"
            label="Distribuidor"
            append-icon="expand_more"
            @change="getIntegrators(tarefa.uuid_dis_id, true)"
            :loading="salvando"
            :disabled="salvando"
            outlined
          >
          </v-autocomplete>
          <v-autocomplete
            v-if="$root.Permissions.admin()"
            :menu-props="{ offsetY: true}"
            v-model="tarefa.uuid_int_id"
            :items="integradoresCadastro"
            clearable
            clear-icon="close"
            label="Integrador"
            append-icon="expand_more"
            :loading="salvando"
            :disabled="salvando"
            outlined
          >
          </v-autocomplete>
          <v-autocomplete
            v-model="tarefa.tar_prioridade"
            autocomplete="off"
            :items="prioridades"
            :loading="salvando"
            :disabled="salvando"
            :rules="[rules.required]"
            label="Prioridade*"
            append-icon="expand_more"
            outlined
          ></v-autocomplete>
          <v-autocomplete
            :clearable="!tarefa.uuid_tar_id"
            clear-icon="close"
            v-model="tarefa.tar_tipo"
            autocomplete="off"
            :items="tipos"
            :loading="salvando"
            :disabled="salvando || !!tarefa.uuid_tar_id"
            :readonly="!!tarefa.uuid_tar_id"
            :rules="[rules.required]"
            label="Tipo*"
            append-icon="expand_more"
            outlined
          ></v-autocomplete>
          <v-menu
            ref="calendarData"
            v-model="calendarData"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                outlined
                label="Data*"
                :rules="[rules.required]"
                append-icon="calendar_today"
                :loading="salvando"
                :disabled="salvando || (!!tarefa.uuid_tar_id && tarefa.tar_tipo === 1)"
                :readonly="!!tarefa.uuid_tar_id && tarefa.tar_tipo === 1"
                v-bind="attrs"
                v-on="on"
                v-model="dataFormatada"
                v-mask="'##/##/####'"
                @input="() => {
                  calendarData = false
                  tarefa.tar_data = $root.Formatter.parseDate(dataFormatada)
                  updatePickerModalData = $root.Formatter.parseDate(dataFormatada)
                }"
              ></v-text-field>
            </template>
            <v-date-picker
              v-if="!tarefa.uuid_tar_id || !!tarefa.uuid_tar_id && tarefa.tar_tipo !== 1"
              :picker-date.sync="updatePickerModalData"
              year-icon="calendar_today"
              prev-icon="chevron_left"
              next-icon="chevron_right"
              :loading="salvando"
              v-model="data"
            ></v-date-picker>
          </v-menu>
          <v-autocomplete
            v-model="tarefa.tar_status"
            autocomplete="off"
            :items="retornaStatus()"
            :loading="salvando"
            :disabled="salvando"
            :rules="[rules.required]"
            label="Status*"
            append-icon="expand_more"
            outlined
          ></v-autocomplete>
          <v-textarea
            outlined
            no-resize
            rows="3"
            v-model="tarefa.tar_descricao"
            :rules="[rules.required]"
            :loading="salvando"
            :disabled="salvando"
            label="Descrição*"
          ></v-textarea>
        </v-form>
        <v-divider></v-divider>
        <v-row no-gutters class="mt-4 mb-0" align="center" justify="space-between">
          <v-btn
            color="cancel"
            :disabled="salvando"
            :loading="salvando"
            @click="closeDialog()"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="primary"
            @click="saveEditTarefa()"
            :loading="salvando"
            :disabled="salvando"
          >
            Salvar
          </v-btn>
        </v-row>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialogDelete"
      max-width="400"
    >
      <v-card class="ui-dialog-top">
        <v-row align="center" justify="space-between">
          <v-col cols="10">
            Remover Tarefa
          </v-col>
          <v-col cols="2" class="text-right">
            <v-icon @click="cancelUsuarioDelete()">close</v-icon>
          </v-col>
        </v-row>
      </v-card>
      <v-card class="ui-dialog-content">
        <div class="text-h3 mb-5">
          Tem certeza que deseja remover esta tarefa?
        </div>
        <v-divider class="mb-3"></v-divider>
        <v-row
          align="center"
          justify="space-between"
          class="px-5 py-5"
        >
          <v-btn
            color="cancel"
            :loading="salvando"
            :disabled="salvando"
            @click="cancelUsuarioDelete()"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="success"
            :loading="salvando"
            :disabled="salvando"
            @click="removeTarefa()"
          >
            Remover
          </v-btn>
        </v-row>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Api from '@API'
import moment from 'moment'
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker'
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css'

export default {
  props: ['abreDialog', 'tarefaSelecionada', 'dataInicio', 'dataFim', 'disableDatePicker'],
  components: {
    VueCtkDateTimePicker
  },
  watch: {
    abreDialog () {
      if (this.abreDialog) this.dialog = true
    },
    tarefaSelecionada () {
      if (this.tarefaSelecionada) this.openDialog(this.tarefaSelecionada)
    },
    data () {
      if (!this.data) this.data = new Date()
      this.dataFormatada = moment(this.data).format('L')
      this.tarefa.tar_data = this.$root.Formatter.parseDate(this.dataFormatada)
      this.calendarData = false
    },
    options: {
      handler () {
        this.getTarefas()
      },
      deep: true
    }
  },
  data () {
    return {
      search: '',
      salvando: false,
      calendarData: false,
      dataFormatada: null,
      data: null,
      updatePickerModalData: '',
      rules: {
        required: value => !!value || 'Obrigatório.'
      },
      distribuidor: null,
      distribuidores: [],
      integrador: null,
      integradores: [],
      cliente: null,
      clientes: [],
      usuario: null,
      usuarios: [],
      tipo: 0,
      tipos: [
        {text: 'Não adiável', color: 'amber darken-4', value: 1},
        {text: 'Adiável', color: 'purple darken-4', value: 2}
      ],
      prioridades: [
        {
          text: 'Alta',
          color: 'red darken-4',
          value: 1
        },
        {
          text: 'Média',
          color: 'orange darken-4',
          value: 2
        },
        {
          text: 'Baixa',
          color: 'amber accent-4',
          value: 3
        }
      ],
      prioridade: 0,
      status: null,
      statusArr: [
        {
          text: 'Aberto',
          color: 'blue',
          value: 1
        },
        {
          text: 'Adiado',
          color: 'amber accent-4',
          value: 2
        },
        {
          text: 'Cancelado',
          color: 'red',
          value: 3
        },
        {
          text: 'Concluído',
          color: 'green',
          value: 4
        }
      ],
      de: moment(new Date()).subtract(30, 'days').format('YYYY-MM-DD'),
      ate: moment(new Date()).add(1, 'month').format('YYYY-MM-DD'),
      data_entrada: {
        start: moment(new Date()).subtract(30, 'days').format('YYYY-MM-DD'),
        end: moment(new Date()).add(1, 'month').format('YYYY-MM-DD')
      },
      total: 0,
      options: {},
      dialog: false,
      dialogDelete: false,
      tarefa: {
        tar_id: '',
        uuid_tar_id: '',
        tar_descricao: '',
        tar_data: new Date(),
        tar_tipo: 2,
        tar_prioridade: 0,
        tar_status: 0
      },
      headers: [
        {
          text: 'ID',
          align: 'start',
          value: 'tar_id'
        },
        { text: 'Data', value: 'tar_data' },
        { text: 'Descrição', value: 'tar_descricao' },
        { text: 'Oportunidade / Cliente', value: 'oportunidade' },
        { text: 'Status', value: 'tar_status' },
        { text: 'Prioridade', value: 'tar_prioridade' },
        { text: 'Usuário', value: 'usuario' },
        { text: 'Tipo', value: 'tar_tipo' },
        { text: 'Distribuidor', value: 'distribuidor.dis_nome' },
        { text: 'Integrador', value: 'integrador.int_nome' },
        { text: 'Revendedor', value: 'revendedor.rev_nome' },
        {
          text: 'Ações',
          value: 'actions',
          align: 'center',
          sortable: false,
          width: 110
        }
      ],
      dados: [],
      labels: [
        { key: 'thisDay', label: 'Hoje', value: 'day' },
        { key: 'last30Days', label: 'Últimos 30 dias', value: 30 },
        { key: 'thisMonth', label: 'Este mês', value: 'month' },
        { key: 'lastMonth', label: 'Mês passado', value: '-month' },
        { key: 'thisYear', label: 'Este ano', value: 'year' },
        { key: 'lastYear', label: 'Último ano', value: '-year' }
      ],
      carregando: false,
      distribuidorAnterior: null,
      integradoresCadastro: []
    }
  },
  methods: {
    async exportXls () {
      this.loadingXls = true
      Api.post('relatorios/exportar', {
        headers: this.someHeader(),
        busca: this.search,
        distribuidor: this.distribuidor ? this.distribuidor : null,
        integrador: this.integrador ? this.integrador : null,
        status: this.status ? this.status : null,
        prioridade: this.prioridade ? this.prioridade : null,
        usuario: this.usuario ? this.usuario : null,
        de: this.de ? this.de : null,
        ate: this.ate ? this.ate : null,
        type: 'tarefas'
      })
        .then(res => {
          this.downloadXls(res.data.url)
          this.removeXls(res.data.url)
          this.loadingXls = false
        })
        .catch(err => {
          console.log(err)
          this.$root.SnackControl.open(this, {
            text: 'Ops, ocorreu um erro ao fazer o donwload!',
            color: 'error'
          })
        })
    },
    async downloadXls (url) {
      const a = document.createElement('a')
      a.href = url
      a.download = url.split('/').pop()
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
    },
    removeXls (url) {
      let data = {
        url: url
      }
      Api.post('relatorios/remove-s3', data)
    },
    someHeader () {
      let cabecalhos = []
      this.headers.map(header => {
        if (header.text !== 'ID' && header.text !== 'Ações' && header.text !== 'Usuários' && header.text !== 'Imagem') cabecalhos.push(header)
      })
      return cabecalhos
    },
    retornaStatus () {
      if (!this.tarefa || this.tarefa.tar_tipo !== 1) return this.statusArr
      return this.statusArr.filter(item => item.value !== 2)
    },
    limparBusca () {
      this.search = null
      this.options.page = 1
      this.applyFilter()
    },
    applyFilter () {
      if (this.distribuidorAnterior && this.distribuidor !== this.distribuidorAnterior) {
        this.integrador = ''
      }

      this.loading = true

      let query = Object.assign({},
        this.de ? { de: this.de } : '',
        this.ate ? { ate: this.ate } : '',
        this.search ? { busca: this.search } : '',
        this.usuario ? { usuario: this.usuario } : '',
        this.distribuidor ? { distribuidor: this.distribuidor } : '',
        this.integrador ? { integrador: this.integrador } : '',
        this.cliente ? { cliente: this.cliente } : '',
        this.prioridade ? { prioridade: this.prioridade } : '',
        this.status ? { status: this.status } : ''
      )

      this.$router.replace({name: this.$route.name, query: query}).catch(() => {})

      if (this.de) {
        this.data_entrada.start = this.de
        if (this.ate) {
          this.data_entrada.end = this.ate
        }
      }

      this.options.page = 1
      this.distribuidorAnterior = this.distribuidor
      this.getIntegrators(this.distribuidor)
      this.getTarefas()
    },
    goToOportunidade (uuid) {
      this.$router.push({ name: 'OportunidadeInterna', params: { uuid } }).catch(() => {})
    },
    goToContact (uuid) {
      this.$router.push({ name: 'Contato', params: { uuid } }).catch(() => {})
    },
    async getTarefas () {
      this.carregando = true
      this.total = 0

      const { page, itemsPerPage } = this.options
      let pagina = 1
      let itensPagina = 1
      let endpoint = ''

      if (page) pagina = page
      if (itemsPerPage) itensPagina = itemsPerPage
      if (this.search) endpoint += `&busca=${this.search}`
      if (this.distribuidor && !this.integrador) endpoint += '&distribuidor=' + this.distribuidor
      if (this.integrador) endpoint += '&integrador=' + this.integrador
      if (this.cliente) endpoint += `&cliente=${this.cliente}`
      if (this.usuario) endpoint += '&usuario=' + this.usuario
      if (this.tipo) endpoint += '&tipo=' + this.tipo
      if (this.prioridade) endpoint += '&prioridade=' + this.prioridade
      if (this.status) endpoint += '&status=' + this.status
      if (this.de) endpoint += `&de=${this.de}`
      if (this.ate) endpoint += `&ate=${this.ate}`

      await Api.get(`tarefas?page=${pagina}&per_page=${itensPagina}${endpoint}`)
        .then(res => {
          if (res.data) {
            let info = []
            if (res.data.data.length > 0) {
              res.data.data.map(item => {
                info.push({
                  tar_id: item.tar_id,
                  uuid_tar_id: item.uuid_tar_id,
                  tar_data: item.tar_data,
                  tar_descricao: item.tar_descricao,
                  oportunidade: item.oportunidade,
                  tar_prioridade: item.tar_prioridade,
                  tar_status: item.tar_status,
                  usuario: item.usuario ? item.usuario.usu_nome : null,
                  tar_tipo: item.tar_tipo,
                  integrador: item.integrador,
                  distribuidor: item.distribuidor,
                  revendedor: item.revendedor
                })
              })
            }
            this.total = res.data.total
            this.dados = info
          }
          this.carregando = false
        })
        .catch(err => {
          this.carregando = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar as tarefas!',
            color: 'error'
          })
          console.log(err)
        })
    },
    saveEditTarefa () {
      if (!this.$refs.formTarefa.validate()) {
        this.$root.SnackControl.open(this, {
          text: 'Por favor, preencha os campos corretamente.',
          color: 'warning'
        })
        return
      }
      this.salvando = true
      let endpoint = 'tarefas/novo'
      let editado = false
      if (this.tarefa.uuid_tar_id) {
        endpoint = 'tarefas/edita'
        editado = true
      }

      if (this.tarefa.uuid_int_id) this.tarefa.uuid_dis_id = null

      Api.post(endpoint, this.tarefa)
        .then((response) => {
          this.salvando = false
          if (response.data.error) {
            this.$root.SnackControl.open(this, {
              text: response.data.error,
              color: 'error'
            })
            return false
          }
          this.$root.SnackControl.open(this, {
            text: editado ? 'Tarefa atualizada com sucesso!' : 'Tarefa cadastrada com sucesso!',
            color: 'success'
          })
          this.closeDialog()
          this.getTarefas()
        })
        .catch((error) => {
          this.salvando = false
          console.log(error.response)
          this.$root.SnackControl.open(this, {
            text: error.response ? error.response.data.msg : 'Ops! Ocorreu um erro!',
            color: 'error'
          })
        })
    },
    removeTarefa () {
      this.salvando = true
      Api.delete(`tarefas/remove/${this.tarefa.uuid_tar_id}`)
        .then(res => {
          this.$root.SnackControl.open(this, {
            text: res.data.msg
          })
          this.dialogExcluir = false
          this.salvando = false
          this.cancelUsuarioDelete()
          this.getTarefas()
        })
        .catch(err => {
          console.log(err)
          this.salvando = false
          this.$root.SnackControl.open(this, {
            text: err.response ? err.response.data.message : 'Erro ao remover tarefa!',
            color: 'error'
          })
        })
    },
    changeDates (dates) {
      this.de = dates.start
      this.ate = dates.end
    },
    retornoData () {
      if (this.data_entrada.start !== this.de || this.data_entrada.end !== this.ate) {
        if (this.data_entrada.end !== null) {
          this.de = this.data_entrada.start
          this.ate = this.data_entrada.end
          this.applyFilter()
        }
      }
    },
    formatDateFront (date, format = 'L') {
      return moment(date).format(format)
    },
    opendialogDelete (item) {
      this.tarefa = item
      this.dialogDelete = true
    },
    openDialog (item) {
      this.tarefa = item
      console.log(this.tarefa)
      this.data = item.tar_data
      this.dialog = true
    },
    openDialogDelete (item) {
      this.dialogDelete = true
    },
    cancelUsuarioDelete () {
      this.closeDialog()
      this.dialogDelete = false
    },
    closeDialog () {
      this.tarefa = {
        tar_id: '',
        uuid_tar_id: '',
        tar_descricao: '',
        tar_data: '',
        tar_prioridade: 0,
        tar_status: 0,
        tar_tipo: 2
      }
      this.data = ''
      setTimeout(() => {
        this.dataFormatada = ''
        if (this.$refs.formTarefa) {
          this.$refs.formTarefa.resetValidation()
        }
      }, 200)
      this.dialog = false
      this.$emit('fecha-cadastro')
    },
    async getIntegrators (distribuidor = null, cadastro = false) {
      this.loadingIntegradores = true
      let url = 'integradores'

      if (distribuidor) {
        url = `distribuidores/${distribuidor}/integradores`
      }
      await Api.get(url)
        .then(res => {
          var arrayInt = []
          res.data.map(int => {
            arrayInt.push({
              'text': int.int_nome,
              'value': int.uuid_int_id
            })
          })
          if (cadastro || (!cadastro && !distribuidor)) {
            this.integradoresCadastro = arrayInt
          }

          if (!cadastro) {
            this.integradores = arrayInt
          }
          this.loadingIntegradores = false
        })
        .catch(err => {
          this.loadingIntegradores = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar os integradores!',
            color: 'error'
          })
          console.log(err)
        })
    },
    getDistributors () {
      Api.get('distribuidores')
        .then(res => {
          if (res.data && res.data.length > 0) {
            let info = []
            res.data.map(item => {
              info.push({
                value: item.uuid_dis_id,
                text: item.dis_nome
              })
            })
            this.distribuidores = info
          }
        })
    },
    getUsers () {
      Api.get('usuarios')
        .then(res => {
          if (res.data && res.data.length > 0) {
            let info = []
            res.data.map(item => {
              info.push({
                value: item.uuid_usu_id,
                text: item.usu_nome
              })
            })
            this.usuarios = info
          }
        })
    },
    removeHeader () {
      if (!this.$root.Permissions.admin()) {
        delete this.headers[10]
        delete this.headers[9]
        delete this.headers[8]
      }
      if (this.$root.Permissions.distributor()) {
        delete this.headers[10]
        delete this.headers[3]
      }
    },
    loadFunctions () {
      this.removeHeader()
      this.getIntegrators(this.distribuidor)
      this.getDistributors()
      this.getUsers()
    },
    loadContent () {
      let filters = this.$route.query
      if (filters.de) this.de = filters.de
      if (filters.ate) this.ate = filters.ate
      if (this.de) {
        this.data_entrada.start = this.de
        if (this.ate) {
          this.data_entrada.end = this.ate
        }
      }
      if (filters.busca) this.search = filters.busca
      if (filters.usuario) this.usuario = filters.usuario
      if (filters.distribuidor) this.distribuidor = filters.distribuidor
      if (filters.integrador) this.integrador = filters.integrador
      if (filters.cliente) this.cliente = filters.cliente
      if (filters.prioridade) this.prioridade = Number(filters.prioridade)
      if (filters.status) this.status = Number(filters.status)

      this.loadFunctions()
    }
  },
  created () {
    if (this.dataInicio) this.de = this.dataInicio
    if (this.dataFim) this.ate = this.dataFim
    this.loadContent()
  }
}
</script>
<style lang="scss" scoped>
@import "@scss/_variables.scss";
@import "@scss/_ui.scss";
.search_data {
  padding-bottom: 10px!important;
  padding-top: 11px!important;
}
.v-chip {
  width: 90px;
  justify-content: center;
}
.tarefa {
  &-link {
    cursor: pointer;
    transition: 0.3s ease;
    &:hover {
      color: $primary;
      transition: 0.3s ease;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/tarefas/ListaTarefas.vue